"use strict";

import Users from "./Users.jsx";

export const auth = true;
export const title = "i18n:users.pageTitle";
export const Component = Users;
